import { OrganizationUnitType } from '@inplay/models';
import { OrgUnit, SubOrganization } from '../../../utils/helper.type';
import { OrgUnitPresentation } from '../orgUnitPresentation.interface';
import {
  OrganizationUnitKey,
  VenuesViewKebabOptions,
  VenuesViewTableHeaderKey,
} from '../../../pages/userManagement/venuesView/venuesView.type';
import { OptionWithLoading } from '../../../pages/userManagement/userManagement.type';
import { VenuesViewTableColumns } from '../orgUnitPresentationTypes';
import { getOrganizationUnitsByTypeAndParent } from '../../../pages/userManagement/venuesView/venuesViewHelper';

export class SubOrganizationPresentationStrategy
  implements OrgUnitPresentation<SubOrganization>
{
  public unitTranslationKey = 'userManagement.subOrganizations';
  public orgUnitType = OrganizationUnitType.SUB_ORGANIZATION;

  getTableData(
    allOrgUnits: OrgUnit[],
    parentOrgUnitId: string | null,
  ): SubOrganization[] {
    if (parentOrgUnitId) {
      return getOrganizationUnitsByTypeAndParent(
        allOrgUnits,
        OrganizationUnitType.SUB_ORGANIZATION,
        parentOrgUnitId,
      ) as SubOrganization[];
    }

    const subOrganizations: SubOrganization[] = allOrgUnits.filter(
      (orgUnit: OrgUnit) =>
        orgUnit.type === OrganizationUnitType.SUB_ORGANIZATION,
    ) as SubOrganization[];

    return subOrganizations;
  }

  getTableColumns(): VenuesViewTableColumns[] {
    return [
      {
        header: VenuesViewTableHeaderKey.SUB_ORG_NAME,
        sortable: true,
        key: OrganizationUnitKey.NAME,
      },
      { header: VenuesViewTableHeaderKey.STATUS },
      { header: VenuesViewTableHeaderKey.ACTIVE_USERS },
      { header: VenuesViewTableHeaderKey.INACTIVE_USERS },
      { header: VenuesViewTableHeaderKey.VENUES },
      { header: VenuesViewTableHeaderKey.VENUE_BRANCHES },
      { header: VenuesViewTableHeaderKey.ADDED_BY },
    ];
  }

  getKebabOptions(): OptionWithLoading<VenuesViewKebabOptions>[] {
    return [
      {
        loading: false,
        label: VenuesViewKebabOptions.EDIT_SUB_ORG,
        value: VenuesViewKebabOptions.EDIT_SUB_ORG,
      },
      {
        loading: false,
        label: VenuesViewKebabOptions.DELETE_SUB_ORG,
        value: VenuesViewKebabOptions.DELETE_SUB_ORG,
      },
    ];
  }
}
